import { Component, OnInit, ɵConsole } from '@angular/core';
declare var $:any;
import { Router } from '@angular/router';
import { ConnectRestService } from '../services/connect-rest.service';
import { EnglishTranslation, MalayTranslation, TransactionConstants, FlowId, ProductCode} from '../app.constants'

@Component({
  selector: 'app-director-confirm',
  templateUrl: './director-confirm.component.html',
  styleUrls: ['./director-confirm.component.scss']
})
export class DirectorConfirmComponent implements OnInit {
product:string;
productDescripion: string;
country = {
  TaxCountry: ''
};
source = {
  name:''
};
  companyDetails = {
    businessName: '',
    registrationNum: '',
    businessType: '',
    emailAddress: '',
    constitution: '',
    businessAddress : {
      addressLine1: '',
      addressLine2: '',
      addressLine3: '',
      countryCode: '',
      stateCode: '',
      postalCode: ''
    },
    businessPremises: '',
    mailingAddress : {
      addressLine1: '',
      addressLine2: '',
      addressLine3: '',
      countryCode: '',
      stateCode: '',
      postalCode: ''
    },
  };
  directorDetails = {
      directorName1: '',
      directorNRIC1: '',
      directorMobile1: '',
      dirctorEmail1: '',
      isUltimateOwner1: '',
      directorAddress: {
        addressLine1: '',
        addressLine2: '',
        addressLine3: '',
        addressLine4: '',
        countryCode: '',
        stateCode: '',
        postalCode: ''
      },
      directorName2:'',
      directorNRIC2:'',
      directorMobile2: '',
      dirctorEmail2: '',
      isUltimateOwner2: '',
      otherUltimateOwner:'',

  };
  businessDetails = {
    mainOperatingCountry: '',
    aboutYourBusiness : '',
    noOfEmployee : '',
    obaoHighRiskIndustry: ''
  };
  transactionDetails = {
    accountUsage:'',
    accountUsageOthers: '',
    activeIncome:'',
    salesOrigin: '',
    customerSupplierLocation:'',
    comingGoingLocation:'',
    transactionCount: '',
    transactionAmount: '',
    incomeFromBusinessRevenue: false,
    proceedsFromInvestment: false,
    incomeFromEmployment: false,
    incomeFromOtherSources: false,
    incomeFromOtherSourceValue: '',
    supplier: [],
    customer: [],
    isExpectedSupplier: '',
    isExpectedCustomer: '',
    taxInfoMalaysia: false,
    taxInfoUSA: false,
    taxInfoOthers: false,
    dealingWithCrimea: ''
  };
  CardDetailList = [];
  businessBanking = {
    DuitNow: false,
    IsBusinessDebitCard: false,
    IsOneCollectSelected: "",
    BusinessLocation: '',
    PreferredOCBCBranch: '',
    eAlertsSelected: false
  };
  accountName: any;
  labels ={
    directorDetails: '',
    director1: '',
    director2: ''
  }

  CustomerLocation: any;
  GoodServicesDestination: any;

  FlowNo: any;
  showFlow: boolean; 
  isFirstDirectorFlow: boolean = false;
  isSecondDirectorFlow: boolean = false;
  isSalesAssisted: boolean = false;
  textContent: any;
  langTranslation: any;
  currentProduct: any;
  ProductCode: any = ProductCode;

  constructor(public router: Router,
    private connectRestService: ConnectRestService) { }

  ngOnInit() {
    this.getDirectorDetails();
    this.langTranslation = sessionStorage.getItem("language");
    this.currentProduct = sessionStorage.getItem("currentProduct");
    this.textContent = this.langTranslation == 'en-us' || this.langTranslation == undefined ? EnglishTranslation.DirectorReviewScreen : MalayTranslation.DirectorReviewScreen;
  }

  // method to call retrieval api
  public async getDirectorDetails() {
    const responseData = await this.connectRestService.connectRest('','R0120', '');
    var locStorage=JSON.parse(localStorage.getItem("URLParam"))
    this.product=locStorage.Product
    this.productDescripion=locStorage.ProductDescription
    this.accountName = this.productDescripion
    if (responseData.Status === 'Success') {
      this.setFormData(responseData);
      
      var directorDetails = responseData['ConnectedParties']
       delete directorDetails[0]['CapturedDocuments']
      if(directorDetails.length>1){
        delete directorDetails[1]['CapturedDocuments']
      }
      sessionStorage.directorDetails = JSON.stringify(directorDetails)
      // this.IsD1FinalSubmission = responseData.CompanyInfo.IsD1FinalSubmission
    }
  }

  public setFormData(responseData){
  const flowId = JSON.parse(sessionStorage.getItem('ServiceHeader')).Flow;
  this.isFirstDirectorFlow = flowId === FlowId.FirstDirectorFlow ? true : false;
  this.isSecondDirectorFlow = flowId === FlowId.SecondDirectorFlow ? true : false;
  
  //this.FlowNo = JSON.parse(sessionStorage.getItem('ServiceHeader')).Flow;
  //console.log(flowId);
  if (flowId == 1 || flowId == 2) {
    this.showFlow = false;
  } else {
    this.showFlow = true;
  }

  // dropdown's List
  const countryList = JSON.parse(sessionStorage.RefCCDL);
  const stateList = JSON.parse(sessionStorage.RefSCDL);
  const constitutionList = JSON.parse(sessionStorage.RefCODL);
  const businessPremisesList = JSON.parse(sessionStorage.RefBPDL);
  const partytype = JSON.parse(sessionStorage.RefET);
  const totalAmountInTransactions = JSON.parse(sessionStorage.RefETDL);
  const totalNumberOfTransactions = JSON.parse(sessionStorage.RefNTDL);
  const accountUsage = JSON.parse(sessionStorage.RefPADL);
  const kycQuestionnaires = responseData.KYCQuestionnaires;

  if (responseData.CompanyDetails.MSICList && responseData.CompanyDetails.MSICList[0]) {
    var MSICCode = responseData.CompanyDetails.MSICList[0].MSIC;
    var MSICDescription = responseData.CompanyDetails.MSICList[0].MSICDescription;
    sessionStorage.setItem('MSICList', JSON.stringify([MSICCode, MSICDescription]));
  }

  //CustomerLocation
  this.CustomerLocation = responseData.KYCQuestionnaires.CustomerLocation;

  //GoodServicesDestination
  this.GoodServicesDestination = responseData.KYCQuestionnaires.GoodServicesDestination;

  // account name
  this.accountName = responseData.AccountDetails && responseData.AccountDetails[0].ProductDescription;

  // sales assisted
  this.isSalesAssisted = responseData.SalesAssisted === true ? true : false;

  // company details
  this.companyDetails.businessName = responseData.CompanyDetails.BusinessName;
  this.companyDetails.registrationNum = responseData.CompanyDetails.BusinessRegNo;
  this.companyDetails.businessType = responseData.CompanyDetails.BusinessType;
  if(this.companyDetails.businessType == "C"){
    this.companyDetails.businessType = "Sdn Bhd";
  }else {
    this.companyDetails.businessType = "Sole Proprietorship/ Partnership";
  }
  //this.companyDetails.emailAddress = responseData.CompanyInfo.ContactInfo[0].Value;
  this.companyDetails.constitution = responseData.CompanyDetails.Constitution;
  //this.companyDetails.businessPremises = businessPremisesList.filter(business => {return business.Code === responseData.CompanyInfo.BusinessPremisesCode})[0].Value;
  if (responseData.CompanyInfo.AddressInfo &&  responseData.CompanyInfo.AddressInfo.length > 0){
    let businessAddress = responseData.CompanyInfo.AddressInfo[0];
    if(businessAddress.AddressLine1 == ""){
      this.companyDetails.businessAddress.addressLine1 = businessAddress.Address;
    }else {
      this.companyDetails.businessAddress.addressLine1 = businessAddress.AddressLine1;
      this.companyDetails.businessAddress.addressLine2 = businessAddress.AddressLine2;
      this.companyDetails.businessAddress.addressLine3 = businessAddress.AddressLine3;
      this.companyDetails.businessAddress.countryCode = countryList.filter(country => {return country.Code === businessAddress.CountryCode})[0].Value;
      if (businessAddress.StateCode){
        this.companyDetails.businessAddress.stateCode = stateList.filter(state => {return state.Code === businessAddress.StateCode})[0].Value;
      }
      this.companyDetails.businessAddress.postalCode = businessAddress.PostalCode;
    }
    
  }
  if (responseData.CompanyInfo.AddressInfo &&  responseData.CompanyInfo.AddressInfo.length > 1){
    let mailingAddress = responseData.CompanyInfo.AddressInfo[1];
    this.companyDetails.mailingAddress.addressLine1 = mailingAddress.AddressLine1;
    this.companyDetails.mailingAddress.addressLine2 = mailingAddress.AddressLine2;
    this.companyDetails.mailingAddress.addressLine3 = mailingAddress.AddressLine3;
    this.companyDetails.mailingAddress.countryCode = countryList.filter(country => {return country.Code === mailingAddress.CountryCode})[0].Value;
    if (mailingAddress.StateCode){
      this.companyDetails.mailingAddress.stateCode = stateList.filter(state => {return state.Code === mailingAddress.StateCode})[0].Value;
    }
    this.companyDetails.mailingAddress.postalCode = mailingAddress.PostalCode;
  }
   // labels for director detals
    // const constitution =  responseData.CompanyInfo && responseData.CompanyDetails.BusinessType;
    var constitution = this.companyDetails.constitution;
    if (this.langTranslation == 'en-us' || this.langTranslation == undefined) {
      if (constitution === "Sole Proprietor") {
        this.labels.directorDetails = "Owner's Details";
        this.labels.director1 = "Owner 1";
        this.labels.director2 = 'Owner 2';
      } else if (constitution === "Partnership") {
        this.labels.directorDetails = "Partner's Details";
        this.labels.director1 = "Partner 1";
        this.labels.director2 = 'Partner 2';
      } else if (constitution === "Sdn Bhd") {
        this.labels.directorDetails = "Director's Details";
        this.labels.director1 = "Director 1";
        this.labels.director2 = 'Director 2';
      }
    } else {
      if (constitution === "Sole Proprietor") { 
        this.labels.directorDetails = "Butiran Pemilik";
        this.labels.director1 = "Pemilik 1";
        this.labels.director2 = 'Pemilik 2';
      } else if (constitution === "Partnership")
      { 
        this.labels.directorDetails = "Butiran Rakan Kongsi"; 
        this.labels.director1 = "Rakan kongsi 1";
        this.labels.director2 = 'Rakan Kongsi 2';
      } else if (constitution === "Sdn Bhd") {
        this.labels.directorDetails = "Butiran Pengarah";
        this.labels.director1 = "Pengarah 1"; 
        this.labels.director2 = 'Pengarah 2';
      }
    }
    
   // director details
   this.directorDetails.directorName1 =responseData.ConnectedParties[0].Name;
   this.directorDetails.directorNRIC1 =responseData.ConnectedParties[0].DisplayNRIC;
   this.directorDetails.dirctorEmail1 =responseData.ConnectedParties[0].Email
   this.directorDetails.directorMobile1 =responseData.ConnectedParties[0].mobileNumber
   //this.directorDetails.isUltimateOwner1 =responseData.ConnectedParties[0].UltimateOwner ? 'Yes' : 'No';
 /*   if (responseData.ApplicantList[0].AddressInfo &&responseData.ConnectedParties[0].AddressInfo.length > 0) {
      const directorAddress =responseData.ConnectedParties[0].AddressInfo[0];
      this.directorDetails.directorAddress.addressLine1 = directorAddress.AddressLine1;
      this.directorDetails.directorAddress.addressLine2 = directorAddress.AddressLine2;
      this.directorDetails.directorAddress.addressLine3 = directorAddress.AddressLine3;
      this.directorDetails.directorAddress.addressLine4 = directorAddress.AddressLine4;
      this.directorDetails.directorAddress.countryCode = countryList.filter(country => { return country.Code === directorAddress.CountryCode })[0].Value;     
      if (directorAddress.StateCode) {
        this.directorDetails.directorAddress.stateCode = stateList.filter(state => { return state.Code ===responseData.ConnectedParties[0].AddressInfo[0].StateCode })[0].Value;
      }
      this.directorDetails.directorAddress.postalCode = directorAddress.PostalCode;
    }
    */
   //this.directorDetails.otherUltimateOwner = responseData.CompanyInfo.OtherUltimateOwner ? 'Yes': 'No';
  if(responseData && responseData.ConnectedParties[1] && responseData.ConnectedParties[1].Name){
   this.directorDetails.directorName2 =responseData.ConnectedParties[1].Name;
   this.directorDetails.directorNRIC2 =responseData.ConnectedParties[1].DisplayNRIC;
   this.directorDetails.dirctorEmail2 =responseData.ConnectedParties[1].Email
   this.directorDetails.directorMobile2 =responseData.ConnectedParties[1].mobileNumber
   //this.directorDetails.isUltimateOwner2 =responseData.ConnectedParties[1].UltimateOwner ? 'Yes' : 'No';
  }

   // business details
   this.businessDetails.mainOperatingCountry = countryList.filter(country => {return country.Code === kycQuestionnaires.MainOperatingCountry})[0].Value;
   this.businessDetails.aboutYourBusiness = kycQuestionnaires.AboutYourBusiness;
   this.businessDetails.noOfEmployee = kycQuestionnaires.NoofEmployee;
   this.businessDetails.obaoHighRiskIndustry =kycQuestionnaires.OBAOHighRiskIndustry === 'Yes' ? 
    'Yes, some of the above' : 'No, none of the above';

  // business banking
  this.businessBanking.DuitNow = responseData.CompanyInfo.DuitNow;
  this.businessBanking.IsBusinessDebitCard = responseData.CompanyInfo.IsBusinessDebitCard;
  this.businessBanking.IsOneCollectSelected = responseData.CompanyInfo.IsOneCollectSelected;
  this.businessBanking.eAlertsSelected = responseData.CompanyInfo.eAlertsSelected
  this.CardDetailList = responseData.CardDetailList;
  this.businessBanking.BusinessLocation = responseData.CompanyInfo.BusinessLocation;
  this.businessBanking.PreferredOCBCBranch = responseData.CompanyInfo.PreferredOCBCBranch;

  // transaction details
  this.transactionDetails.accountUsage = accountUsage.filter(acc => {return acc.Code === kycQuestionnaires.AccountUsage.Value})[0].Value
  this.transactionDetails.accountUsageOthers = kycQuestionnaires.AccountUsage.Other;
  this.transactionDetails.salesOrigin = countryList.filter(country => {return country.Code === kycQuestionnaires.SalesOrigin.Country})[0].Value;
  // this.transactionDetails.customerSupplierLocation = countryList.filter(country => {return country.Code === kycQuestionnaires.CustomerSupplierLocation.Country})[0].Value;
 // this.transactionDetails.comingGoingLocation = countryList.filter(country => {return country.Code === kycQuestionnaires.ComingGoingLocation.Country})[0].Value;
  this.transactionDetails.transactionAmount = totalAmountInTransactions.filter(amount => {return amount.Code === kycQuestionnaires.OutflowFund})[0].Value;
  this.transactionDetails.transactionCount = totalNumberOfTransactions.filter(count => {return count.Code === kycQuestionnaires.InflowFund})[0].Value;
  this.transactionDetails.activeIncome = kycQuestionnaires.ActiveIncome ? 'Yes': 'No';
    for (let country of responseData.TaxInfo) {
      if (country.TaxCountry === TransactionConstants.TaxInfoMalaysia) {
        this.transactionDetails.taxInfoMalaysia = country.IsSelected;
      } else if (country.TaxCountry === TransactionConstants.TaxInfoUSA) {
        this.transactionDetails.taxInfoUSA = country.IsSelected;
      } else if (country.TaxCountry === TransactionConstants.TaxInfoOthers) {
        this.transactionDetails.taxInfoOthers = country.IsSelected;
      }
    }
    for (let source of kycQuestionnaires.SourceOfFund) {
      if (source.Name === TransactionConstants.BusinessInvestment) {
        this.transactionDetails.incomeFromBusinessRevenue = source.IsSelected;
      } else if (source.Name === TransactionConstants.IncomeFromEmployment) {
        this.transactionDetails.incomeFromEmployment = source.IsSelected;
      } else if (source.Name === TransactionConstants.ProceedsFromBusiness) {
        this.transactionDetails.proceedsFromInvestment = source.IsSelected;
      } else if (source.Name === TransactionConstants.IncomeFromOtherSources) {
        this.transactionDetails.incomeFromOtherSources = source.IsSelected;
        if (source.IsSelected) {
          this.transactionDetails.incomeFromOtherSourceValue = source.Other;
        }
      }
    }
    this.transactionDetails.isExpectedCustomer = kycQuestionnaires.NoExpectedCustomer ? 'I do not have the names yet' : '';
    if (kycQuestionnaires.ExpectedCustomer && kycQuestionnaires.ExpectedCustomer.length > 0 && !kycQuestionnaires.NoExpectedCustomer) {
      for (let customer of kycQuestionnaires.ExpectedCustomer) {
        this.transactionDetails.customer.push({
          name: customer.Name,
          // added PartyType
          partyType: partytype.filter(partytype => { return partytype.Code === customer.PartyType})[0].Value,
          //country: countryList.filter(country => { return country.Code === customer.Country })[0].Value
        });
      }
    }
    if(kycQuestionnaires.NoExpectedCustomer){
      this.transactionDetails.customer = [];
    }
    this.transactionDetails.isExpectedSupplier = kycQuestionnaires.NoExpectedSupplier ? 'I do not have the names yet': ''
    if (kycQuestionnaires.ExpectedSupplier && kycQuestionnaires.ExpectedSupplier.length > 0 && !kycQuestionnaires.NoExpectedSupplier) {
      for (let supplier of kycQuestionnaires.ExpectedSupplier) {
        this.transactionDetails.supplier.push({
          name: supplier.Name,
          // added PartyType
          partyType: partytype.filter(partytype => { return partytype.Code === supplier.PartyType})[0].Value,
          // country: countryList.filter(country => { return country.Code === supplier.Country })[0].Value
        });
      }
    }

    if(kycQuestionnaires.NoExpectedSupplier){
      this.transactionDetails.supplier = [];
    }
    this.transactionDetails.dealingWithCrimea = kycQuestionnaires.Crimea;

    // documents 
    if(this.isFirstDirectorFlow){
      if (responseData.ConnectedParties[0].CapturedDocuments && responseData.ConnectedParties[0].CapturedDocuments.length > 0) {
        for (let document of responseData.ConnectedParties[0].CapturedDocuments) {
          if (document.Type === 'NRICFront') {
            $('#img-ic-f').attr('src', document.Value);
          } else if (document.Type === 'NRICBack') {
            $('#img-ic-b').attr('src', document.Value);
          } else if (document.Type === 'Signature') {
            $('#img-sign').attr('src', document.Value);
          }
        }
      }
    }else if(this.isSecondDirectorFlow){
      if (responseData.ConnectedParties[1].CapturedDocuments && responseData.ConnectedParties[1].CapturedDocuments.length > 0) {
        for (let document of responseData.ConnectedParties[1].CapturedDocuments) {
          if (document.Type === 'NRICFront') {
            $('#img-ic-f').attr('src', document.Value);
          } else if (document.Type === 'NRICBack') {
            $('#img-ic-b').attr('src', document.Value);
          } else if (document.Type === 'Signature') {
            $('#img-sign').attr('src', document.Value);
          }
        }
      }
    }
    
    if (responseData.CompanyInfo.CapturedDocuments && responseData.CompanyInfo.CapturedDocuments.length > 0) {
      const documentValue = responseData.CompanyInfo.CapturedDocuments[0].Value;
      const documentExtType = responseData.CompanyInfo.CapturedDocuments[0].ExtensionType;
      if (documentExtType === 'pdf') {
        $('#img-doc').attr('src', 'assets/images/PDF.png');
      } else if (documentExtType.toLowerCase() === "jpg" || documentExtType.toLowerCase() === "jpeg") {
        $('#img-doc').attr('src', documentValue);
      }
    }

  }

  // method to redirect to corresponding page
  public redirectToPage(path){
    if (path === '/director-details' && this.isSecondDirectorFlow){
      path = '/second-director-details'
    }
    this.router.navigate([path, {edit:true}]);
  }
  
  // new logic applied for OMC/2MC

  async onSubmit(isCorrectionRequried){
    var requestID = "";
    var flowID = "";
    if(this.isFirstDirectorFlow){
      requestID = "S0120";
      const responseData = await this.connectRestService.connectRest('', requestID, '');
      var showLastStep = JSON.parse(sessionStorage.getItem('ServiceHeader')).IsD2Available
      if(responseData && responseData.Status == "Success" && !showLastStep) {   
        sessionStorage.FinalResponse = JSON.stringify(responseData);
        if (responseData['IsCorrectionRequried']){
          this.router.navigate(['/thank-you-director']);
        } else {
          if(responseData['IsEKYCAvailable']=="true") {
            this.router.navigate(['/thank-you-application']);
          } else {
            this.router.navigate(['/one-more-step-without-ekyc']);
          }
        }       
      } else if(responseData && responseData.Status == "Success" && showLastStep){
        sessionStorage.FinalResponse = JSON.stringify(responseData);
       
        this.router.navigate(['/last-step']);
      } else if(responseData){
        sessionStorage.FinalResponse = JSON.stringify(responseData);
      }
    }else if(this.isSecondDirectorFlow){
      this.restConnect(isCorrectionRequried);
    }
  }

   // method for update api
   public async restConnect(isCorrectionRequried) {
    var requestID = "S0121";
    var data = {};
    if(this.isSecondDirectorFlow){
      if(isCorrectionRequried === 'required'){
        data = {"IsCorrectionRequried": true}
      } else{
        data = {"IsCorrectionRequried": false}
      }      
    }
    const responseData = await this.connectRestService.connectRest(data, requestID, '');
    var flowID = JSON.parse(sessionStorage.getItem('ServiceHeader')).Flow;   
    if(responseData && responseData.Status == "Success" && flowID == "2"){
      sessionStorage.FinalResponse = JSON.stringify(responseData);
      if(isCorrectionRequried === 'required'){
        sessionStorage.directorDetails = responseData['Name']
        this.router.navigate(['/correction-request']);
      }else if(responseData['IsEKYCAvailable']=="true"){
          this.router.navigate(['/thank-you-application']); 
      }else{
        this.router.navigate(['/one-more-step-without-ekyc']);
      }   
    }
  }

}
